import React from "react";
import {useEffect, useState} from 'react'
import { useParams} from 'react-router-dom';

import AITestContext from '../../../contexts/AITestContext'
import AuthContext from "../../../contexts/AuthContext.js";

export const  Return = () => {
  const {connectedAccountId} = useParams();
  const [account, setAccount] = useState({})

  let {
    getConnectedAccount,
  } = React.useContext(AITestContext);

  const {
    currentUser,
} = React.useContext(AuthContext);
 

  useEffect(() => {
   
    const fetchConnectedAccount = async () => {
     let res = await getConnectedAccount(currentUser)

      console.log("useEffect: Return: response:", res)

      if (res.status === 404)
        {
          console.log("User not found")
          return
        }

      setAccount(res)

    }

    fetchConnectedAccount()
 
  }, [currentUser,getConnectedAccount])


  return (
    <div className="container">
     
      <div className="banner">
        <h2>Account has not been created.</h2>
      </div>
      <div className="content">
        {
          !account.verifed &&
            <h4>You must complete identity verification before you can start accepting payments.</h4>
        }
       
        <p>Connected account id: {connectedAccountId}</p>
      </div>
      <div className="info-callout">
        <p>
        This is a sample app for Stripe-hosted Connect onboarding. <a href="https://docs.stripe.com/connect/onboarding/quickstart?connect-onboarding-surface=hosted" target="_blank" rel="noopener noreferrer">View docs</a>
        </p>
      </div>
    </div>
  );
}